import styled from "styled-components";

export const WebhookWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding-top: 20px;

  > button {
    width: auto;
    height: 20px;
  }

  label {
    color: #fff;
  }
`;
